import { Component, ViewContainerRef  } from '@angular/core';
import { DiscountType } from '../../../models/coupons/discount-type-model';
import { DiscountTypeService } from '../../../services/coupons/discount-type.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { RolePermissionService } from '../../../services/role/role-permission.service';
@Component({
    selector: 'app-create-discount-type',
    templateUrl: './create-discount-type.component.html',
    styleUrls: ['./create-discount-type.component.scss']
})
/** create-discount-type component*/
export class CreateDiscountTypeComponent {
  public discountTypeModel = new  DiscountType();
  validate: boolean;
  /** create-discount-type ctor */
  constructor(private readonly discountTypeService: DiscountTypeService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("discountype").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.discountTypeModel = new DiscountType();
            this.toastr.setRootViewContainerRef(vcr);
            this.discountTypeModel.isActive = true;
            this.discountTypeModel.discountNatureType = null;
            this.validate = true;
          }
          else {
            this.router.navigate(["/discount-types"]);
          }
        }
        else {
          this.router.navigate(["/discount-types"]);
        }
      }
    )

  }
  isActiveCheckbox(e) {
    this.discountTypeModel.isActive = e.target.checked;
  }

  onSubmit() {
    this.validate = false;
    this.discountTypeService.AddDiscountType(this.discountTypeModel).subscribe(result => {
      if (result) {
        this.toastr.success('Discount Type has been Saved.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/discount-types"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Success');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/coupons/discount-type/create-discount-type/create-discount-type.component.ts